export function isEmpty<T>(value: T | null | undefined): value is null {
  return value == null;
}

export function isNotEmpty<T>(value: T | null | undefined): value is T {
  return !isEmpty(value);
}

export function filterEmpty<T>(value: T | null | undefined | false): value is T {
  return value !== null && value !== undefined && value !== false;
}
